export default "__VITE_ASSET__CXz7k8Yq__"